// @flow
/** @jsx jsx */

import * as React from 'react';

import { Colors } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

type ChildrenProps = {
  children: React.Node,
};

type CellProps = {
  children: React.Node,
  isHeader?: boolean,
};

const border = `1px solid ${Colors.adamantium}`;

const baseCellCss = {
  lineHeight: 1.5,
  padding: '0.5em 1em',
};

const bodyCellCss = css(baseCellCss, {
  color: Colors.steel,
});

const bodyRowCss = {
  ':not(:last-child)': {
    borderBottom: border,
  },
  ':hover': {
    backgroundColor: Colors.storm,
  },
};

const headerCellCss = css(baseCellCss, {
  borderBottom: border,
  color: Colors.deepSpace,
  fontWeight: 400,
});

const simpleTableCss = {
  fontSize: '1.6rem',
};

const tableCss = {
  borderCollapse: 'collapse',
  margin: 0,
};

export const Table = ({ children }: ChildrenProps) => {
  return (
    <div css={simpleTableCss}>
      <table css={tableCss}>{children}</table>
    </div>
  );
};

export const TableBody = ({ children }: ChildrenProps) => (
  <tbody>{children}</tbody>
);

export const TableCell = ({ children }: ChildrenProps) => (
  <td css={bodyCellCss}>{children}</td>
);

export const TableHead = ({ children }: ChildrenProps) => (
  <thead>{children}</thead>
);

export const TableHeadCell = ({ children }: ChildrenProps) => (
  <th css={headerCellCss}>{children}</th>
);

export const TableRow = ({ children }: CellProps) => (
  <tr css={bodyRowCss}>{children}</tr>
);
